import React from "react";
import { ScopeSwitcherWrap, ScopeTab } from "../styles";
import { LABELS } from "../labels";
import type { TextRegistryScope } from "../types";

interface Props {
	scope: TextRegistryScope;
	onChange: (scope: TextRegistryScope) => void;
}

const SCOPES: { id: TextRegistryScope; label: string }[] = [
	{ id: "admin", label: LABELS.scopeAdmin },
	{ id: "homepage", label: LABELS.scopeHomepage },
	{ id: "stations", label: LABELS.scopeStations },
];

export default function ScopeSwitcher({ scope, onChange }: Props) {
	return (
		<ScopeSwitcherWrap>
			{SCOPES.map((s) => (
				<ScopeTab
					key={s.id}
					active={scope === s.id}
					onClick={() => onChange(s.id)}>
					{s.label}
				</ScopeTab>
			))}
		</ScopeSwitcherWrap>
	);
}
